/**
 * Timezone-aware formatting for a scheduled visit window.
 *
 * The backend sends `scheduled_start_at` / `scheduled_end_at` as ISO-8601 UTC
 * instants plus `scheduled_timezone` (IANA, e.g. 'Europe/Warsaw'). We render the
 * dates in that timezone. Existing helpers in `viewServiceRequestHelpers.ts`
 * hardcode 'Europe/Warsaw'; this one takes the timezone as a parameter so the
 * "Moje zadania" list is correct once multi-timezone scheduling lands.
 */

const FALLBACK_TZ = 'Europe/Warsaw';
const EMPTY = '—';

/**
 * Format a single scheduled instant as `YYYY/MM/DD` in the given timezone.
 * Returns `—` for a null/unparseable input.
 */
export function formatScheduledDate(
  iso: string | null | undefined,
  timeZone: string | null | undefined
): string {
  if (!iso) {
    return EMPTY;
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return EMPTY;
  }
  const map: Record<string, string> = {};
  for (const p of new Intl.DateTimeFormat('en-GB', {
    timeZone: timeZone || FALLBACK_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(d)) {
    map[p.type] = p.value;
  }
  return `${map['year']}/${map['month']}/${map['day']}`;
}
